import * as API from '../utilities/api';
import moment from 'moment';
import { getDiscount } from '../selectors/discount';
import { selectDiscount, removePromo } from './discount';
import { InputStep } from '../components/Checkout/Checkout';

export const CAPTCHA_COMPLETE = 'CAPTCHA_COMPLETE';
export const CAPTCHA_EXPIRE = 'CAPTCHA_EXPIRE';
export const FETCH_SESSION_TOKEN = 'FETCH_SESSION_TOKEN';
export const RECEIVE_SESSION_TOKEN = 'RECEIVE_SESSION_TOKEN';
export const EXPIRE_SESSION_TOKEN = 'EXPIRE_SESSION_TOKEN';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_EMAIL2 = 'SET_EMAIL2';
export const SET_FIRST_NAME = 'SET_FIRST_NAME';
export const SET_LAST_NAME = 'SET_LAST_NAME';
export const SET_PHONE = 'SET_PHONE';

export const TOGGLE_GTI_Receipt = "TOGGLE_GTI_Receipt";
export const SET_CUSNUMBER = 'SET_CUSNUMBER';

export const SET_PROVINCIA = 'SET_PROVINCIA';
export const SET_PROVINCIA_ID = 'SET_PROVINCIA_ID';

export const SET_CANTONS = 'SET_CANTONS';
export const SET_CANTON_ID = 'SET_CANTON_ID';

export const SET_DISTRITOS = 'SET_DISTRITOS';
export const SET_DISTRITO_ID = 'SET_DISTRITO_ID';

export const SET_BARRIOS = 'SET_BARRIOS';
export const SET_BARRIO_ID = 'SET_BARRIO_ID';

export const SET_DIRECCION = 'SET_DIRECCION';
export const SET_TIPO_IDENT = 'SET_TIPO_IDENT';
export const SET_TIPO_DOC = 'SET_TIPO_DOC';
export const SET_AREA_TELEFONO = 'SET_AREA_TELEFONO';
export const SET_NUM_TELEFONO = 'SET_NUM_TELEFONO';
export const SET_CORREO = 'SET_CORREO';
export const SET_FULL_NAME = 'SET_FULL_NAME';
export const RESET_GTI = 'RESET_GTI';

export const SET_PROMO = 'SET_PROMO';
export const REMOVE_PROMO_TEXT = 'REMOVE_PROMO_TEXT';
export const RECEIVE_CHECKOUT_INFO = 'RECEIVE_CHECKOUT_INFO';
export const SET_ACCEPT_TERMS = 'SET_ACCEPT_TERMS';
export const SET_HAS_YOUNG_CHILDREN = 'SET_HAS_YOUNG_CHILDREN';
export const SET_CUSTOMER_CARD_NUMBER = 'SET_CUSTOMER_CARD_NUMBER'
export const SET_USED_LOCAL_STORAGE = 'SET_USED_LOCAL_STORAGE';

export function receiveSessionToken(sessionToken, purchaseCode, signedAuthorizationRequest) {
  return {
    type: RECEIVE_SESSION_TOKEN,
    sessionToken,
    purchaseCode,
    signedAuthorizationRequest
  };
}

export function expireSessionToken() {
  return {
    type: EXPIRE_SESSION_TOKEN
  };
}

export function setEmail(email) {
  return {
    type: SET_EMAIL,
    email
  };
}

export function setEmail2(email2) {
  return {
    type: SET_EMAIL2,
    email2
  };
}

export function setFirstName(firstName) {
  return {
    type: SET_FIRST_NAME,
    firstName
  };
}

export function setLastName(lastName) {
  return {
    type: SET_LAST_NAME,
    lastName
  };
}

export function setPhone(phone) {
  return {
    type: SET_PHONE,
    phone
  };
}

export function setCusNumber(cusNumber) {
  return {
    type: SET_CUSNUMBER,
    cusNumber
  };
}

export function getProvincias() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      API.getProvincia()
        .then((response) => {
          let provincia = response;

          dispatch({
            type: SET_PROVINCIA,
            provincia
          });

          resolve({
            type: SET_PROVINCIA,
            provincia
          });
        }).catch((error) => {
          console.log("Error getting Provincia");
          console.log(error);
        });
    })
  }
}


export function getCantons(provinciaId) {
  return (dispatch, getState) => {

    return new Promise((resolve, reject) => {
      API.getCantons(provinciaId)
        .then((response) => {
          let cantons = response;
          dispatch({
            type: SET_CANTONS,
            cantons
          });

          resolve({
            type: SET_CANTONS,
            cantons
          });
        }).catch((error) => {
          console.log("Error getting Cantons");
          console.log(error);
        });
    })
  }
}
export function getDistritos(cantonId) {
  return (dispatch, getState) => {
    let state = getState();

    return new Promise((resolve, reject) => {
      API.getDistritos(state.checkout.provinciaId, cantonId)
        .then((response) => {
          let distritos = response;

          dispatch({
            type: SET_DISTRITOS,
            distritos
          });

          resolve({
            type: SET_DISTRITOS,
            distritos
          });
        }).catch((error) => {
          console.log("Error getting Distritos");
          console.log(error);
        });
    })
  }
}

export function getBarrios(distritoId) {
  return (dispatch, getState) => {
    let state = getState();

    return new Promise((resolve, reject) => {
      API.getBarrios(state.checkout.provinciaId, state.checkout.cantonId, distritoId)
        .then((response) => {
          let barrios = response;

          dispatch({
            type: SET_BARRIOS,
            barrios
          });

          resolve({
            type: SET_BARRIOS,
            barrios
          });
        }).catch((error) => {
          console.log("Error getting Barrios");
          console.log(error);
        });
    })
  }
  
}

export function toggleGTIReceipt(GTIReceipt) {
  return {
    type: TOGGLE_GTI_Receipt,
    GTIReceipt
  };
}

export function setProvinciaId(provinciaId) {
  return {
    type: SET_PROVINCIA_ID,
    provinciaId
  };
}

export function setCantonId(cantonId) {
  return {
    type: SET_CANTON_ID,
    cantonId
  };
}

export function setDistritoId(distritoId) {
  return {
    type: SET_DISTRITO_ID,
    distritoId
  };
}

export function setBarrioId(barrioId) {
  return {
    type: SET_BARRIO_ID,
    barrioId
  };
}

export function setDireccion(direccion) {
  return {
    type: SET_DIRECCION,
    direccion
  };
}

export function setTipoIdent(tipoIdent) {
  return {
    type: SET_TIPO_IDENT,
    tipoIdent
  };
}

export function setTipoDoc(tipoDoc) {
  return {
    type: SET_TIPO_DOC,
    tipoDoc
  };
}

export function setAreaTelefono(areaTelefono) {
  return {
    type: SET_AREA_TELEFONO,
    areaTelefono
  };
}

export function setNumTelefono(numTelefono) {
  return {
    type: SET_NUM_TELEFONO,
    numTelefono
  };
}

export function setCorreo(correo) {
  return {
    type: SET_CORREO,
    correo
  };
}

export function setFullName(fullName) {
  return {
    type: SET_FULL_NAME,
    fullName
  };
}

export function resetGTI() {
  return {
    type: RESET_GTI
  };
} 

export function setHasAcceptedTerms(hasAcceptedTerms) {
  return {
    type: SET_ACCEPT_TERMS,
    hasAcceptedTerms
  };
}

export function setHasYoungChildren(hasYoungChildren) {
  return {
    type: SET_HAS_YOUNG_CHILDREN,
    hasYoungChildren
  };
}

function getBestPromo(promos, discounts, state) {

  // multiplied by -1 x offset to counter browser-retrieved time zone
  const date = moment(state.date.selectedDate).add(-1 * moment().utcOffset(), 'm').tz(state.bookingLocation.selectedLocation.time_zone);
  // const date = new Date(state.date.selectedDate);
  // // Artificially raises time by 12 hours to avoid timezone issues with server response
  // date.setHours(date.getHours() + 12);

  let currentDiscountAmt = state.discount.selectedDiscountAmtSaved;

  let curBestDiscount = undefined;

  let failCount = 0;

  for(const key in promos) {
    
    if (!promos[key].discount_id) {
      failCount++;
      continue;
    }
    else if (promos[key].is_used) {
      failCount++;
      continue;
    }

    const dis = discounts.find(discount => {
      // is correct discount
      const thisDiscount = discount.discount_id === promos[key].discount_id;

      // current selected day is redeemable
      const applicableDay = (discount.applicable_days.find(day => {
        return day.day === date.day();
      })).redeemable;

      // discount applies to date range
      const isActive = (moment(discount.active_start).valueOf() <= moment().valueOf())
        && (moment().valueOf() <= moment(discount.active_end).valueOf());

      const isApplicable = (moment(discount.applicable_start).valueOf() <= date.valueOf())
      && (date.valueOf() < moment(discount.applicable_end).valueOf());


      return thisDiscount && applicableDay && isApplicable && isActive;
    });

    if (!dis) {
      failCount++;
      continue;
    }
    const newDiscount = getDiscount(state, dis);
    console.log(newDiscount);
    if (newDiscount.id === '0') {
      failCount++;
      continue;
    }

    if(newDiscount.total > currentDiscountAmt) {
      curBestDiscount = newDiscount;
      currentDiscountAmt = newDiscount.total;
    }
  }

  let err = undefined;

  if(failCount === promos.length) { 
    err = InputStep.NotFound;
  } else if (currentDiscountAmt === state.discount.selectedDiscountAmtSaved && currentDiscountAmt > 0) {
    err = InputStep.FoundNotBetter;
  }

  return {
    obj: curBestDiscount,
    err: err
  };
}

export function trySelectPromo(promo, override) {
  return (dispatch, getState) => {
    const state = getState();
    const locationId = state.bookingLocation.selectedLocationId;
    const discounts = state.discount.discountsData.discounts;

    return new Promise((resolve, reject) => {
      API.checkPromo(promo, locationId)
        .then(result => {

          // backwards compatability
          if(!Array.isArray(result)) result = [result];
          console.log(result);

          if(result.length === 0) {
            reject(InputStep.NotFound);
            return;
          }

          let bestDiscount = getBestPromo(result, discounts, state);

          if(bestDiscount.obj === undefined) {
            reject(bestDiscount.err);
          } else {
            bestDiscount.obj.isPromoDiscount = true;
            bestDiscount.obj.promo = promo;
            bestDiscount.obj.forcePromo = override;
            dispatch(selectDiscount(bestDiscount.obj));
            resolve(InputStep.FoundBetter);
          }
        })
        .catch(() => reject(InputStep.NotFound));
    });
  }
}

export function resetDiscount() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch(removePromo());
      const discount = getDiscount(getState());
      dispatch(selectDiscount(discount));
      resolve();
    });
  }
}

export function setPromo(promo) {
  return {
    type: SET_PROMO,
    promo
  };
}

export function removePromoText() {
  return {
    type: REMOVE_PROMO_TEXT
  };
}

export function completeCaptcha(response) {
  return {
    type: CAPTCHA_COMPLETE,
    response
  };
}

export function expireCaptcha() {
  return {
    type: CAPTCHA_EXPIRE
  };
}

export function fetchCheckoutInfo() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      if (state.bookingLocation.selectedLocationId === null) {
        reject('No locationId for checkout info');
      }
      else {
        API.getCheckoutInformation(state.bookingLocation.selectedLocationId)
          .then(result => {
            dispatch(receiveCheckoutInfo(result.uses_crowd_ctrl_gift_card));
            resolve();
          })
          .catch(error => {
            console.error('Failed to get checkout info: ' + error);
            reject(error);
          });
      }
    });
  }
}

export function receiveCheckoutInfo(giftCardEnabled) {
  return {
    type: RECEIVE_CHECKOUT_INFO,
    giftCardEnabled
  };
}

export function setCustomerCardNumber(customerCardNumber) {
  return {
    type: SET_CUSTOMER_CARD_NUMBER,
    customerCardNumber
  }
}

export function setUsedLocalStorage() {
  let usedLocalStorage = true;
  return {
    type: SET_USED_LOCAL_STORAGE,
    usedLocalStorage
  }
}